
export enum ProfileAccessType {
    PARTIAL = 'PARTIAL',
    FULL = 'FULL'
}
export interface AccessibilityVO {
    accessType: ProfileAccessType;
    includeSummary?: boolean;
    sections?: string[];
    contents?: string[];
    sectionContentsMap?: {[key: string]: string[]};
}
